<template>
  <div v-if="fieldType == 'checkbox'">
    <v-checkbox
      :label="label"
      :input-value="fieldValue"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
    >
    </v-checkbox>
  </div>

  <div v-else-if="fieldType == 'switch'">
    <v-switch
      :label="label"
      :input-value="fieldValue"
      :false-value="false"
      :true-value="true"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
    >
    </v-switch>
  </div>

  <div v-else>
    <v-checkbox
      :label="label"
      :value="fieldValue"
      :false-value="false"
      :true-value="true"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
    >
    </v-checkbox>
  </div>
</template>

<script>
export default {
  props: ["label", "fieldName", "object", "fieldType"],
  computed: {
    fieldValue: {
      get: function() {
        // Could not retrieve employee data from store state
        // return this.$store.state.employees.detailedEmployee[this.fieldName];

        //  Instead get data from object passed as prop
        return this.object[this.fieldName];
      },
      set: function(newValue) {
        this.loading = true;
        this.$store
          .dispatch("employees/update", {
            id: this.object.id || this.object.userId,
            [this.fieldName]: newValue
          })
          .then(res => {
            this.errors = [];
            this.successes.push("Saved!");
            this.successClear = setInterval(() => {
              this.wipeSuccesses();
            }, 1500);
          })
          .catch(res => {
            this.errors.push("Couldn't be saved");
            // reset the value?
          })
          .finally(res => {
            this.loading = false;
          });
      }
    }
  },

  methods: {
    wipeSuccesses: function() {
      this.successes = [];
    }
  },

  data: function() {
    return {
      loading: false,
      fallback: "",
      errors: [],
      successes: []
    };
  }
};
</script>
